import { createFileRoute } from "@tanstack/react-router";

import TenantDetailPage from "@/features/dashboard/pages/tenant-detail";

function TenantDetailRoute() {
  const { tenantPublicId } = Route.useParams();
  return <TenantDetailPage tenantPublicId={tenantPublicId} />;
}

export const Route = createFileRoute("/(app)/dashboard/tenants/$tenantPublicId")({
  component: TenantDetailRoute,
});
